import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

/**
 * Phone-only ticket chrome: the context header that replaces the desktop masthead ticket bar, the
 * field strip under it, and the two bottom sheets that replace the overlay drawer + icon rail.
 */
export const phoneTicketStyles = StyleSheet.create({
	header: {
		flex: 'none',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		padding: `12px ${spacing.md}px 10px`,
		borderBottom: `1px solid ${colors.border.light}`,
		backgroundColor: colors.background.light,
	},
	headerTopRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		minWidth: 0,
	},
	ticketNumber: {
		flex: 'none',
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	headerSpacer: {
		flexGrow: 1,
	},
	primaryAction: {
		flex: 'none',
		height: 36,
		gap: 6,
		padding: `0 ${spacing.md - 2}px`,
	},
	overflowButton: {
		flex: 'none',
		width: 44,
		height: 44,
		padding: 0,
		color: colors.text.light,
	},
	subject: {
		fontSize: 17,
		fontWeight: typography.fontWeights.bold,
		lineHeight: 1.3,
		// @ts-expect-error aphrodite's CSSProperties has no -webkit-box display value
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
		overflow: 'hidden',
		overflowWrap: 'anywhere',
	},
	contactRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		minWidth: 0,
	},
	contactAvatar: {
		width: 22,
		height: 22,
		minWidth: 22,
		fontSize: typography.fontSizes.xxs,
	},
	contactText: {
		minWidth: 0,
		fontSize: 13,
		color: colors.text.light,
		...common.truncate,
	},
	strip: {
		flex: 'none',
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		minWidth: 0,
		padding: `${spacing.sm}px ${spacing.md}px`,
		borderBottom: `1px solid ${colors.border.light}`,
		backgroundColor: colors.background.main,
	},
	// Both field controls share the row evenly and truncate rather than pushing the Details button off.
	stripControl: {
		flexGrow: 1,
		flexShrink: 1,
		flexBasis: 0,
		minWidth: 0,
	},
	stripTrigger: {
		width: '100%',
		height: 36,
		minWidth: 0,
		backgroundColor: colors.background.light,
	},
	detailsButton: {
		flex: 'none',
		height: 36,
		gap: spacing.xs,
		padding: `0 ${spacing.xs}px`,
	},
	sheet: {
		'--drawer-inset': '0px',
		'--drawer-bleed-background': colors.background.light,
		'--drawer-content-height': '86dvh',
		'--drawer-content-max-height': '86dvh',
		borderRadius: `${spacing.md}px ${spacing.md}px 0 0`,
		borderBottom: 'none',
	},
	assistantSheet: {
		'--drawer-inset': '0px',
		'--drawer-bleed-background': colors.background.light,
		'--drawer-content-height': '92dvh',
		'--drawer-content-max-height': '92dvh',
		borderRadius: `${spacing.md}px ${spacing.md}px 0 0`,
		borderBottom: 'none',
	},
	// DrawerHeader stacks and centres its children by default; a sheet title needs a title row.
	sheetHeader: {
		flex: 'none',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.sm,
		padding: `${spacing.xs}px ${spacing.sm}px ${spacing.sm}px ${spacing.md}px`,
		borderBottom: `1px solid ${colors.border.light}`,
		textAlign: 'left',
	},
	sheetTitle: {
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
	},
	sheetDone: {
		flex: 'none',
		height: 44,
		padding: `0 ${spacing.sm}px`,
	},
	sheetBody: {
		flexGrow: 1,
		minHeight: 0,
		overflowY: 'auto',
		padding: spacing.md,
		...common.scrollBar,
	},
	assistantSheetBody: {
		flexGrow: 1,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
	},
	assistantEmpty: {
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: spacing.sm,
		padding: spacing.lg,
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		textAlign: 'center',
	},
});
